const baseRoute = '/customer-feature-allowlisting'

export const CustomerFeatureAllowlistingAreaRoutes = {
  route: baseRoute,
  index: {
    path: '/',
  },
}
